import React, { useState } from "react";
import { Input, Button, Select, DropdownProps, InputOnChangeData } from "semantic-ui-react";
import FilterBuilder, { IFields } from "./FilterBuilder";

export type TSearch = "simples" | "avancado";

export interface ISearch {
    searchString: string;
    type: TSearch;
}

interface IProps {
    placeholder: string;
    filterType?: "simples" | "avancado";
    onSearch: ({ searchString, type }: ISearch) => void;
    filterFields?: IFields[];
}

const Search: React.FC<IProps> = ({ placeholder, onSearch, filterFields, filterType }) => {

    const [search, setSearch] = useState<string>("");
    const [type, setType] = useState<TSearch>("simples");

    const options: { key: string, text: string, value: TSearch }[] = [

        { key: "simples", text: "Simples", value: "simples" },
        { key: "avancado", text: "Avançado", value: "avancado" }
    ];

    const onChangeSearch = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setSearch(data.value);

        if (data.value.length === 0) {
            onSearch({ searchString: data.value, type });
        }
    }

    const onChangeSearchType = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        setSearch("");

        setType(data.value as TSearch);
        onSearch({ searchString: search.toUpperCase(), type });
    }

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13) {
            onSearch({ searchString: search.toUpperCase(), type });
        }
    }

    const handleOnSuccessFilterBuilder = (filter: string) => {
        setSearch(filter);
        onSearch({ searchString: filter.toUpperCase(), type });
    }

    return (
        <>
            <Input
                fluid
                action
                actionPosition={type === "avancado" && (filterFields && filterFields.length > 0) ? "left" : undefined}
                type="text"
                placeholder={type === "simples" ? placeholder : "Expressão avançada"}
                onChange={onChangeSearch}
                onKeyDown={handleOnKeyDown}
                labelPosition="right"
            >
                {type === "avancado" && (filterFields && filterFields.length > 0) && <FilterBuilder fields={filterFields} onSuccess={handleOnSuccessFilterBuilder} />}
                <input value={search} />
                {(filterType === undefined || filterType === "avancado") &&
                    <Select
                        compact
                        options={options}
                        onChange={onChangeSearchType}
                        defaultValue="simples"
                    />
                }
                <Button icon="search" onClick={() => onSearch({ searchString: search.toUpperCase(), type })} />
            </Input>
        </>
    );
}

export default Search;
